import { render } from "./getDiscount.vue?vue&type=template&id=41097906&scoped=true"
import script from "./getDiscount.vue?vue&type=script&lang=js"
export * from "./getDiscount.vue?vue&type=script&lang=js"

import "./getDiscount.vue?vue&type=style&index=0&id=41097906&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41097906"]])

export default __exports__